import React from 'react';

export const ChildSupportTextMin = () => {
  return (
    <>
      <p>Що входить в роботу:</p>
      <p>✔️консультації на всьому етапі справи(тел.);</p>
      <p>✔️підготовка позовної заяви, або заяви про видачу судового наказу;</p>
      <p>✔️інструкція, як подати документи і що робити далі в суді;</p>
    </>
  );
};
